import {
  getToolGridCardWidthPx,
  TOOL_GRID_MIN_CARD_WIDTH,
} from '@/components/Tools/toolGridLayout';

export { getToolGridCardWidthPx as getPromptGridCardWidthPx, TOOL_GRID_MIN_CARD_WIDTH as PROMPT_GRID_MIN_CARD_WIDTH };

/** Prompts catalog defaults to 3 columns on desktop (Galaxy-style). */
export const PROMPT_GRID_MAX_COLUMNS = 3;

/** Compact related-recipe grids on tool detail pages — up to 5 per row. */
export const PROMPT_GRID_COMPACT_MAX_COLUMNS = 5;
export const PROMPT_GRID_COMPACT_MIN_CARD_WIDTH = 140;

export function getPromptGridColumnCount(bodyWidth, gap = 12, options = {}) {
  const maxColumns = options.maxColumns ?? PROMPT_GRID_MAX_COLUMNS;
  const minCardWidth = options.minCardWidth ?? TOOL_GRID_MIN_CARD_WIDTH;
  const w = typeof bodyWidth === 'number' && bodyWidth > 0 ? bodyWidth : 360;
  const eff = Math.max(160, w);
  for (let n = maxColumns; n >= 1; n -= 1) {
    const slot = (eff - (n - 1) * gap) / n;
    if (slot >= minCardWidth) return n;
  }
  return 1;
}
